<template>
  <div class="agent-manager" style="display: flex;">
    <!-- Left: List Table -->
    <div style="flex: 4; padding: 24px 0 0px 24px;    background: rgb(101, 101, 101);border-radius: 20px;    margin-right: 10px;    text-align: left;">
      <!-- Search Bar -->
      <el-input
        placeholder="输入昵称或VXID查找代理"
        prefix-icon="el-icon-search"
        v-model="search"
        clearable
        class="round-input"
        style="margin-bottom: 12px; width: 360px;"
      />
      <!-- Table -->
      <el-table
        :data="filteredAgents"
        border
        height="calc(100vh - 180px)"
        style="width: 100%; background: rgb(101, 101, 101); color: #fff;"
        @row-click="handleRowClick"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="nick_name" label="代理昵称"></el-table-column>
        <el-table-column prop="wx_id" label="VXID"></el-table-column>
        <el-table-column prop="expire_time" label="到期时间" sortable>
          <template #default="{ row }">
            {{ formatDateString(row.expire_time) }}
          </template>
        </el-table-column>

        <el-table-column prop="create_time" label="添加时间" sortable>
          <template #default="{ row }">
            {{ formatDateString(row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="代理类型">
          <template slot-scope="scope">
            {{ formatType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="recharge_amount" label="代理余额" sortable :sort-method="sortRechargeAmount"></el-table-column>
      </el-table>
    </div>

    <!-- Right: Form Panel-->
    <div style="flex: 1; border-radius: 16px;">
      <!-- Add Agent Form -->
      
      <!-- Edit Agent Form -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          <i class="el-icon-edit"></i> 查询代理详情
        </div>
      <el-card shadow="never" style="background: #656565; color: #fff;">
        
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="选择时间">
                <el-date-picker
            v-model="querytime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 250px;">
          </el-date-picker>
        </el-form-item>
          <el-form-item label="代理昵称">
            <span>{{ editForm.nick_name || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="代理VXID">
            <span>{{ editForm.wx_id || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="添加时间">
            <span>{{ formatDateString(editForm.create_time) || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="到期时间">
            <span>{{ formatDateString(editForm.expire_time) || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="代理类型">
            <span>{{ formatType(editForm.type) || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="代理余额">
            <span>{{ formatType(editForm.recharge_amount) || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="实收金额">
            <span>{{ totalReceipts }}元</span>
          </el-form-item>
          <div style="text-align:left;margin-top: 30px;">
            <span>卡密统计</span>
            <div class="usage-row" :key="item.car_mode" v-for="item in statistics">
              <span>{{ item.name }}</span>
              <span>{{ item.count }}张</span>
              <span>{{ item.receipts }}元</span>
            </div>
          </div>
          <div>
            <el-button size="small" type="primary" @click="getStatistics" style="margin-left: 12px;">查询统计</el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name:"PowerPage",
  data() {
    return {
      search: '',
      selectedRowId: null,
      types: [
        {
          name:'储值代理',
          val:1
        },{
          name:'月结代理',
          val:2
        }],
      agents: [
        
      ],
      statistics:[],
      querytime:'',
      addForm: {
        nickname: '',
        wxid: '',
        type: '',
        rechargeamount: '',
        expiretime: ''
      },
      editForm: {
        nickname: '',
        wxid: '',
        type: '',
        rechargeamount: '',
        expiretime: ''
      },
    }
  },
  computed: {
    filteredAgents() {
      if (!this.search) return this.agents;
      const keyword = this.search.toLowerCase().trim();
      return this.agents.filter(agent =>
        (agent.nick_name && agent.nick_name.toLowerCase().includes(keyword)) ||
        (agent.wx_id && agent.wx_id.toLowerCase().includes(keyword))
      );
    },
    // 👇 新增一个总和计算
    totalReceipts() {
      return this.statistics.reduce((sum, item) => {
        return sum + (parseFloat(item.receipts) || 0);
      }, 0).toFixed(2);
    }
  },
  methods: {
    handleRowClick(row) {
      console.log(row)
      this.selectedRowId = row.id;
      // 选中后把这行数据放到 editForm
      this.editForm = {
        ...row
      };
    },
    sortRechargeAmount(a, b) {
      // 把字符串转成数字，防止空字符串或异常
      const valA = parseFloat(a.recharge_amount) || 0;
      const valB = parseFloat(b.recharge_amount) || 0;
      return valA - valB;
    },
    tableRowClassName({ row }) {
      return row.id === this.selectedRowId ? 'selected-row' : '';
    },
    formatType(val) {
      const found = this.types.find(item => item.val === val);
      console.log(found)
      return found ? found.name : val;
    },
    formatDateString(dateStr) {
      if (!dateStr) return '-';
      return dateStr.split(' ')[0]; // "2025-07-16 00:00:00" => "2025-07-16"
    },
    async proxyList(){
      try {
        const res = await this.$axios.post('/proxy/list', {
          'search':this.search
        })
        this.agents = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async addProxy() {

      try {
        console.log(this.addForm)
        const res = await this.$axios.post('/proxy/create', {
          ...this.addForm
        })

        console.log(res);
      } catch (err) {
        console.log(err);
      }
      

      this.agents.push({ ...this.addForm});
      this.$message.success('添加成功');
      this.addForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
    },
    updateAgent() {
      const idx = this.agents.findIndex(a => a.vxid === this.editForm.vxid);
      if (idx > -1) {
        this.agents[idx] = { ...this.editForm, group: 39 };
        this.$message.success('修改成功');
      }
    },
    deleteAgent() {
      this.agents = this.agents.filter(a => a.vxid !== this.editForm.vxid);
      this.$message.success('删除成功');
      this.editForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
    },
    async cardPriceList(){
      try {
        const res = await this.$axios.post('/carmine/cardprice', {
        })
        this.cardprices = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getStatistics(){
      try {
        const res = await this.$axios.post('/carmine/statistics', {
          'id':this.editForm.id,
          'querytime':this.querytime
        })
        this.statistics = res.data;
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    // 选中左侧表格某行时编辑
    filteredAgents: {
      handler(val) {
        // 可以绑定el-table @row-click事件来填充editForm
        console.log(val)
      }
    }
  },
  mounted() {
    this.cardPriceList();
    this.proxyList();
  }
}
</script>

<style scoped>

::v-deep .el-table .el-table__body-wrapper tbody tr.selected-row > td.el-table__cell {
  background-color: #b0b0b0 !important;
  color: #fff !important;
}
.agent-manager {
  font-family: "PingFang SC", "Helvetica Neue", Arial, "Microsoft YaHei", sans-serif;
}
.el-table th, .el-table td, .el-table tr,el-table__row {
  background: #404040 !important;
  /* color: #000 !important; */
  border-color: #656565 !important;
}
.el-table .el-table__body tr {
  background-color: rgb(101, 101, 101) !important;
}
.el-card {
  border-radius: 12px !important;
  border: none !important;
}
.round-input .el-input__inner {
  border-radius: 20px;
}

::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  background-color: rgb(101, 101, 101) !important;
  color: #fff !important;
}

/* 方式 1：v-deep */
::v-deep .el-table,
::v-deep .el-table th,
::v-deep .el-table td {
  border: none !important;
}

/* 如果还有伪元素残留，也可以干掉 */
::v-deep .el-table::before {
  display: none;
}

/* 去掉表头底部分割线 */
::v-deep .el-table__header-wrapper th {
  border-bottom: none !important;
}

/* 去掉表格行的分割线 */
::v-deep .el-table__row td {
  border-bottom: none !important;
}

::v-deep .el-form-item__label {
  color: #fff !important;
}

::v-deep .el-form-item {
    margin-bottom: 0px;
}

/* ::v-deep .el-input--prefix .el-input__inner {
    border-radius: 20px;
} */

::v-deep .el-date-editor{
  width:250px;
}

.usage-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* 三等分 */
  padding: 6px 0;
}

.usage-header {
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}
</style>